import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=14e0303a"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e0303a')) {
      api.createRecord('14e0303a', component.options)
    } else {
      api.reload('14e0303a', component.options)
    }
    module.hot.accept("./Inbox.vue?vue&type=template&id=14e0303a", function () {
      api.rerender('14e0303a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/Inbox.vue"
export default component.exports